import { render, staticRenderFns } from "./AddCar.vue?vue&type=template&id=2439a3c6&scoped=true&"
import script from "./AddCar.vue?vue&type=script&lang=js&"
export * from "./AddCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439a3c6",
  null
  
)

export default component.exports